import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import React from 'react'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import { i18n, Game } from './Core'

import * as tutorialSelectors from './Tutorial/tutorial.selectors'
import TutorialScreen from './Tutorial'

// Importar los contextos modernos
import { GameContextProvider } from './Core/contexts/GameContext'
import { UIContextProvider } from './Core/contexts/UIContext'

/**
 *  Root component that renders the whole app with modern Context API
 */
const Root = ({ locale, messages, store, isTutorial }) => {
  // Ensure locale is always valid for react-intl v5
  const validLocale = locale || 'en'
  
  return (
    <Provider store={store}>
      <GameContextProvider>
        <UIContextProvider>
          <IntlProvider key={validLocale} locale={validLocale} messages={messages}>
            {!isTutorial ? <Game.Game /> : <TutorialScreen />}
          </IntlProvider>
        </UIContextProvider>
      </GameContextProvider>
    </Provider>
  )
}

const mapStateToProps = (state) => ({
  locale: i18n.selectors.getI18nLocale(state),
  messages: i18n.selectors.getI18nMessages(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
})

Root.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  store: PropTypes.object.isRequired,
  isTutorial: PropTypes.bool,
}

export default connect(mapStateToProps)(Root)
